import LinkText from "../../../../components/LinkText";

import { getLabel } from "../../../../hooks/use-labels";
import { store } from "../../../../redux";
import {
  saveOrder,
  setOrderInformation,
} from "../../../../redux/reducers/order/order-action";

import {
  format12HourTime,
  formatAddress,
  formatCurrency,
  formatListMomentDate,
  getErrorCode,
  getStorageItem,
  handleError,
} from "../../../../utils/common-utils";

import { getOtherProductsQuantity } from "../../../SupplierDetail/ProductDetailModal/ProductDetails/product-cart-detail-utils";
import { formatTypeSpanText } from "./DeliveryTypesCard/DeliveryTypeModal/DeliveryTypeContent/type-content-utils";

const formatDeliveryTime = ({ date, from, till }) => {
  const formattedStart = format12HourTime(date, from, true);
  const formattedEnd = format12HourTime(date, till, true);

  return `${formattedStart} - ${formattedEnd}`;
};

export const prepareDeliveryInformation = (deliveryDetails, deliveryAddress, showMap) => {


  const { code, defaultTitle, timeSlot } = deliveryDetails;

  const hasDeliveryLatLong =
    deliveryAddress && +deliveryAddress.latitude && +deliveryAddress.longitude;

  return [
    {
      label: getLabel("orderDeliveryType"),
      value: getLabel(code) || defaultTitle,
    },
    ...(timeSlot
      ? [
          { label: getLabel("deliveryDate"), value: formatListMomentDate(timeSlot.date) },
          {
            label: getLabel("deliveryTime"),
            value: formatDeliveryTime(timeSlot),
          },
        ]
      : [
          {
            label: getLabel("deliverIn"),
            value: formatTypeSpanText(deliveryDetails),
          },
        ]),
    {
      label: getLabel("deliveryAddress"),
      value: hasDeliveryLatLong ? (
        <LinkText
          text={formatAddress(deliveryAddress, true)}
          onClick={showMap}
          fontClass="text-xs"
          className="word-break"
        />
      ) : (
        formatAddress(deliveryAddress)
      ),
    },
  ];
};

export const prepareCartTotal = ({ totalAmount, totalVAT, label }) => {
  return [
    {
      label: label || `${getLabel("totalLabel")}:`,
      value: (
        <div className="font-20-bold-500 flex align-center cart-total-content">
          {formatCurrency(+totalAmount.value, totalAmount.currency)}
        </div>
      ),
    },
    ...(totalVAT
      ? [
          {
            label: `${getLabel("vatAmountLabel")}:`,
            labelItemClass: "secondary-color font-16-bold-500-lh-20",
            valueItemClass: "secondary-color font-16-bold-500-lh-20",
            value: formatCurrency(+totalVAT.value, totalVAT.currency),
          },
        ]
      : []),
  ];
};

export const canProceedCart = (carts) => {
  const deliveryAddress = getStorageItem("deliveryAddress");
  const deliveryType = getStorageItem("deliveryType");
  const quantity = getOtherProductsQuantity(carts);

  return Boolean(quantity && deliveryAddress && deliveryType);
};

export const getOrderInfoRequest = () => {
  const cart = getStorageItem("carts");
  const deliveryType = getStorageItem("deliveryType");

  const deliveryAddress = getStorageItem("deliveryAddress");
  const savedOrder = getStorageItem("orderInfo");

  const { id, timeSlot } = deliveryType || { id: "", timeSlot: "" };
  const { date, from, till } = timeSlot || {};

  const requestDetails = {
    cartId: cart.cartId,
    deliveryTypeId: id,
    ...(timeSlot && { deliveryOn: { date, from, till } }),
    deliveryAddress,
    ...(savedOrder &&
      savedOrder.cartInfo.coupon && {
        couponCode: savedOrder.cartInfo.coupon.code,
      }),
  };

  return requestDetails;
};

export const saveOrderDetails = ({ successCB, errorCB }, otherRequest) => {
  const orderRequest = getOrderInfoRequest();

  saveOrder({
    ...orderRequest,
    ...(otherRequest && otherRequest),
  })
    .then(({ data }) => {
      const { dispatch } = store;

      dispatch(setOrderInformation(data));
      successCB();
    })
    .catch((error) => {
      const code = getErrorCode(error);
      const message = handleError(error);
      errorCB({ message, code });
    });
};

export const hasExistingCart = () => {
  const cart = getStorageItem("carts");
  const deliveryAddress = getStorageItem("deliveryAddress");
  const deliveryType = getStorageItem("deliveryType");

  const hasCart = cart || deliveryAddress || deliveryType;

  return hasCart
};